export default __webpack_public_path__ + "static/media/logout-white.5c1478f6.svg";